/**
 * Animations - Vanilla JS
 * Handles scroll-based visibility animations using Intersection Observer
 */

import { ready, $$ } from "./utils.js";

/**
 * Check if element is visible in viewport (partial or full)
 * @param {Element} el - Element to check
 * @param {boolean} partial - If true, check partial visibility
 * @returns {boolean}
 */
function isVisible(el, partial = true) {
  const rect = el.getBoundingClientRect();
  const viewportHeight =
    window.innerHeight || document.documentElement.clientHeight;

  if (partial) {
    // Element is partially visible
    return rect.top < viewportHeight && rect.bottom > 0;
  } else {
    // Element is fully visible
    return rect.top >= 0 && rect.bottom <= viewportHeight;
  }
}

ready(() => {
  const modules = $$(".module");

  // Use Intersection Observer for better performance (modern approach)
  if ("IntersectionObserver" in window) {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1, // Trigger when 10% is visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("come-in");
          // Optionally unobserve after animation
          // observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Check initial visibility and observe
    modules.forEach((el) => {
      if (isVisible(el, true)) {
        el.classList.add("already-visible");
      }
      observer.observe(el);
    });
  } else {
    // Fallback for older browsers
    modules.forEach((el) => {
      if (isVisible(el, true)) {
        el.classList.add("already-visible");
      }
    });

    // Throttled scroll handler
    let ticking = false;
    window.addEventListener("scroll", () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          modules.forEach((el) => {
            if (isVisible(el, true) && !el.classList.contains("come-in")) {
              el.classList.add("come-in");
            }
          });
          ticking = false;
        });
        ticking = true;
      }
    });
  }
});
